import Preact from 'preact';

var FormStructure = {
    fields: {
        headerLabel: {
            validations: []
        },
        website: {
            validations: []
        },
        accountExtra2: {
            validations: []
        },
        firstName: {
            validations: [
                { type: 'required', message: 'This field is required.' }
            ]
        },
        lastName: {
            validations: [
                { type: 'required', message: 'This field is required.' }
            ]
        },
        cellNumber: {
            validations: [
                { type: 'required', message: 'This field is required.' },
                { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid cell phone number.' }
            ]
        },
        email: {
            validations: [
                { type: 'required', message: 'This field is required.' },
                { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
            ]
        },
        EventDate: {
            validations: [
                { type: 'dateinfuture', message: 'Event date must be in the future.' },
                { type: 'required', message: 'This field is required.' }
            ]
        },
        EventExtra7: {
            validations: [
                { type: 'dateinfuture', message: 'Event date must be in the future.' },
                { type: 'required', message: 'This field is required.' }
            ]
        },
        PlannedGuestCount: {
            validations: [
                { type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.' },
                { type: 'required', message: 'This field is required.' }
            ]
        },
        EventExtra8: {
            validations: [
                { type: 'required', message: 'This field is required.' }
            ]
        },
        Reference: {
            validations: [
                { type: 'required', message: 'This field is required.' }
            ]
        },
        notes: {
            validations: []
        }
    },
    layout: {
        rows: [{
                fields: [{
                        type: 'text',
                        size: 'Medium',
                        label: 'First Name (required)',
                        mapping: 'firstName',
                        customClasses: ['no-label']
                    },
                    {
                        type: 'text',
                        size: 'Medium',
                        label: 'Last Name (required)',
                        mapping: 'lastName',
                        customClasses: ['no-label']
                    }
                ]
            },
            {
                fields: [{
                        type: 'text',
                        size: 'Medium',
                        label: 'Phone (required)',
                        mapping: 'cellNumber',
                        customClasses: ['no-label']
                    },
                    {
                        type: 'text',
                        size: 'Medium',
                        label: 'Email (required)',
                        mapping: 'email',
                        customClasses: ['no-label']
                    },
                ]
            },
            {
                fields: [{
                    type: 'date-picker-nofill',
                    size: 'Medium',
                    label: 'Wedding Date - 1st Preference',
                    mapping: 'EventDate',
                    customClasses: ['no-label']
                }]
            },
            {
                fields: [{
                    type: 'date-picker-nofill',
                    size: 'Medium',
                    label: 'Wedding Date - 2nd Preference',
                    mapping: 'EventExtra7',
                    customClasses: ['no-label']
                }]
            },
            {
                fields: [{
                    type: 'text',
                    size: 'Medium',
                    label: 'Estimated Number of Guests',
                    mapping: 'PlannedGuestCount',
                    customClasses: ['no-label']
                }]
            },
            {
                fields: [{
                    type: 'multiple-choice-nolabel',
                    size: 'Medium',
                    label: 'Estimated Budget',
                    options: [
                        { label: '$10,001 - $20,000', value: '$10,001 - $20,000' },
                        { label: '$20,001 - $30,000', value: '$20,001 - $30,000' },
                        { label: '$30,001 - $40,000', value: '$30,001 - $40,000' },
                        { label: '$40,001 - $50,000', value: '$40,001 - $50,000' },
                        { label: '$50,000+', value: '$50,000+' },
                    ],
                    mapping: 'EventExtra8',
                    customClasses: ['no-label']
                }]
            },
            {
                fields: [{
                    type: 'multiple-choice-nolabel',
                    size: 'Medium',
                    label: 'How did you hear about us?',
                    options: [
                        { label: 'Attended an event', value: 'Attended an event' },
                        { label: 'Bride Online', value: 'Bride Online' },
                        { label: 'Easy Wedding', value: 'Easy Wedding' },
                        { label: 'Family / Friend', value: 'Family / Friend' },
                        { label: 'Google Search', value: 'Google Search' },
                        { label: 'Social Media', value: 'Social Media' },
                        { label: 'Other (please specify below)', value: 'Other (please specify below)' },
                    ],
                    mapping: 'Reference',
                    customClasses: ['no-label']
                }]
            },
            {
                fields: [{
                    type: 'text-area',
                    size: 'Medium',
                    label: 'Additional Notes',
                    mapping: 'notes',
                    customClasses: ['no-label']
                }]
            },
            {
                fields: [{
                    type: 'submit',
                    size: 'XLarge',
                    label: 'SUBMIT'
                }]
            }
        ]
    },
    info: {
        title: 'Contact Form - Fenix',
        formId: '546',
        clientKey: '35D2935E-F31C-4AC4-992F-A8FCF4A5D6D4',
        appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
        redirectUrl: 'https://fenix.com.au/thank-you-for-your-enquiry-with-fenix-events/',
        submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
        apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
    }
};


export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/mapleeventgroup2/form_structure.js